export const LCR_ORDER_QUERY_KEY = "lcrOrder";
